import { BaseScenariosService } from './base-scenarios-service';
import { SavedCareerScenario, CareerComparisonData } from '../types/careerComparison';

class CareerScenariosService extends BaseScenariosService<SavedCareerScenario> {
  protected readonly STORAGE_KEY = 'larryshelp_career_scenarios';
  protected readonly SCENARIO_TYPE = 'career' as const;

  /**
   * Save a new career scenario
   */
  async saveCareerScenario(scenario: Omit<SavedCareerScenario, 'id' | 'createdAt'>): Promise<string> {
    return this.saveScenario(scenario);
  }

  /**
   * Get all career scenarios
   */
  async getAllCareerScenarios(): Promise<Record<string, SavedCareerScenario>> {
    return this.getAllScenarios();
  }

  /**
   * Get a specific career scenario by ID
   */
  async getCareerScenario(id: string): Promise<SavedCareerScenario | null> {
    return this.getScenario(id);
  }

  /**
   * Update an existing career scenario
   */
  async updateCareerScenario(id: string, updates: Partial<SavedCareerScenario>): Promise<boolean> {
    return this.updateScenario(id, updates);
  }

  /**
   * Delete a career scenario
   */
  async deleteCareerScenario(id: string): Promise<boolean> {
    return this.deleteScenario(id);
  }

  /**
   * Get career scenarios as an array (for easier iteration)
   */
  async getCareerScenariosArray(): Promise<SavedCareerScenario[]> {
    return this.getScenariosArray();
  }

  /**
   * Clear all career scenarios
   */
  async clearAllCareerScenarios(): Promise<void> {
    return this.clearAllScenarios();
  }
}

export const careerScenariosService = new CareerScenariosService();
export default careerScenariosService;